import { theme } from '@superhi/design'
import styled from 'styled-components'

type WrapperProps = {
  $backgroundColor?: keyof typeof theme.colors
}

export const Wrapper = styled.div<WrapperProps>`
  overflow: hidden;
  border-radius: 8px;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? theme.colors[$backgroundColor] : ''};

  iframe {
    display: block;
    background-color: transparent;
    width: 100%;
    height: auto;
  }
`
